// components/LoginModal.tsx
import Login from '@/pages/login';
import { Modal } from '@arco-design/web-react';
import React, { useState } from 'react';

interface LoginModalProps {
  visible: boolean;
  onSuccess: () => void;
  onClose: () => void;
}

const LoginModal = ({ visible, onSuccess, onClose }: LoginModalProps) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    // 模拟登录请求
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setLoading(false);
    onSuccess(); // 登录成功后回调
  };

  if (!visible) return null;

  return (
    <Modal visible={visible} onCancel={onClose} footer={null} title={null}>
      <Login onSuccess={onSuccess} />
    </Modal>
  );
};

export default LoginModal;
